const SettingPage = ({}) => {
  return (
    <h2>Страница Настройки</h2>
  );
};

export default SettingPage;